"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Facebook = function Facebook(props) {
	return _react2.default.createElement(
		"svg",
		_extends({}, props, { viewBox: "0 0 48 48" }),
		_react2.default.createElement("path", { d: "M36 40h-7.975V27.987h4.388l.658-3.98h-5.045V20.16c0-1.266.34-2.168 2.157-2.168h2.835V14.2a16.614 16.614 0 0 0-2.844-.225 5.843 5.843 0 0 0-6.177 5.97v4.063H20v3.98h4V40H12a4 4 0 0 1-4-4V12a4 4 0 0 1 4-4h24a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4zm-7.975 0z" })
	);
};

exports.default = Facebook;


//////////////////
// WEBPACK FOOTER
// ./~/react-share-icons/lib/Facebook/index.js
// module id = 171
// module chunks = 0